import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import Box from "@mui/material/Box";

import { StoreState } from "../redux/configure-store";
import MainList from "./menu-list";
import DashboardPage from "../dashboard/dashboard-page";
import TopBar from "../user/components-layout/top-bar";
import MenuDrawer from "../user/components-layout/menu-drawer";
import EngagementsView from "../engagements/EngagementsView";

import { switchMenuDrawer } from "../user/user-actions";
import { navigateToAdminPage } from "./route-actions";

import { parseRouteIdFromProps, routePaths } from "./route-paths";
import SettingsPage from "../user/settings-page";
import ChangePasswordPage from "../authentication/change-password-page";

interface AppRoutesProps {
  pathname: string;
  isMenuDrawerOpen: boolean;
  switchMenuDrawer: () => void;
}

function AppRoutes(props: AppRoutesProps) {
  const { pathname, isMenuDrawerOpen, switchMenuDrawer } = props;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <TopBar />
      <MenuDrawer
        pathname={pathname}
        open={isMenuDrawerOpen}
        handleDrawerClose={switchMenuDrawer}
        ListComponent={MainList}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflow: "auto",
        }}
      >
        {/* Toolbar spacer */}
        <Box sx={{ height: { xs: 56, sm: 64 } }} />

        <Switch>
          <Redirect exact path="/" to={routePaths.dashboard.root} />
          <Route
            exact
            path={routePaths.user.settings}
            render={(props) => <SettingsPage {...props} />}
          />
          <Route
            path={routePaths.auth.changePassword}
            component={ChangePasswordPage}
          />
          <Route
            path={routePaths.dashboard.root}
            render={(props) => <DashboardPage {...props} />}
          />

          <Route
            path={routePaths.engagements.engagementsView}
            render={(props) => (
              <EngagementsView
                engagementPublicId={parseRouteIdFromProps(props, false)}
                {...props}
              />
            )}
          />
        </Switch>
      </Box>
    </Box>
  );
}

const mapStateToProps = (storeState: StoreState) => ({
  pathname: storeState.router.location.pathname,
  isMenuDrawerOpen: storeState.user.isMenuDrawerOpen,
  user: storeState.authentication.user,
});

export default connect(mapStateToProps, {
  switchMenuDrawer,
  navigateToAdminPage,
})(AppRoutes);
